import { render, staticRenderFns } from "./DigitalPromoCredits.vue?vue&type=template&id=61d618dc&"
import script from "./DigitalPromoCredits.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d618dc')) {
      api.createRecord('61d618dc', component.options)
    } else {
      api.reload('61d618dc', component.options)
    }
    module.hot.accept("./DigitalPromoCredits.vue?vue&type=template&id=61d618dc&", function () {
      api.rerender('61d618dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/digital-promo/DigitalPromoCredits.vue"
export default component.exports